import React from "react";
import { Sparkles, CheckCircle2, ArrowUpRight, User } from "lucide-react";
import { MARLEA } from "@/constants/testIds";
import { Logo } from "./Logo";

export const ChatbotMockup = () => {
  return (
    <div
      className="relative"
      data-testid={MARLEA.mockupCard}
      role="img"
      aria-label="Voorbeeld van Marlea AI chatbot op een website"
    >
      <div className="absolute -inset-8 -z-10 opacity-70 pointer-events-none">
        <div
          className="absolute top-0 left-0 w-56 h-56 rounded-full blur-3xl"
          style={{ background: "radial-gradient(circle, rgba(168,255,0,0.18), transparent 70%)" }}
        />
        <div
          className="absolute bottom-0 right-0 w-64 h-64 rounded-full blur-3xl"
          style={{ background: "radial-gradient(circle, rgba(0,239,255,0.22), transparent 70%)" }}
        />
      </div>

      <div className="relative glass-strong rounded-2xl p-4 md:p-5 shimmer-border glow-cyan">
        <div className="flex items-center justify-between mb-4">
          <Logo size={24} />
          <div className="flex items-center gap-1.5 px-2 py-1 rounded-full bg-white/5 border border-white/10">
            <span className="h-1.5 w-1.5 rounded-full bg-[#A8FF00] pulse-dot" />
            <span className="text-[9px] uppercase tracking-wider text-[#A7A7A7]">Online 24/7</span>
          </div>
        </div>

        <div className="space-y-2.5">
          <div className="flex items-start gap-2">
            <div className="h-6 w-6 rounded-full bg-[#161C2E] border border-white/10 flex items-center justify-center shrink-0">
              <User className="h-3 w-3 text-[#A7A7A7]" />
            </div>
            <div className="max-w-[85%] rounded-2xl rounded-tl-sm bg-white/[0.04] border border-white/10 px-3.5 py-2">
              <p className="text-[13px] text-white/90 leading-relaxed">
                &ldquo;Kunnen jullie mij helpen en wat kost dit ongeveer?&rdquo;
              </p>
            </div>
          </div>

          <div className="flex items-start gap-2 justify-end">
            <div
              className="max-w-[85%] rounded-2xl rounded-tr-sm px-3.5 py-2 border"
              style={{
                background:
                  "linear-gradient(135deg, rgba(168,255,0,0.08), rgba(0,239,255,0.06))",
                borderColor: "rgba(0,239,255,0.25)",
              }}
            >
              <p className="text-[13px] text-white leading-relaxed">
                Zeker. Ik stel enkele korte vragen en stuur uw aanvraag overzichtelijk
                door.
              </p>
            </div>
            <div className="h-6 w-6 rounded-full bg-gradient-neon flex items-center justify-center shrink-0">
              <Sparkles className="h-3 w-3 text-[#0A0A1A]" strokeWidth={2.5} />
            </div>
          </div>

          <div className="flex items-center gap-1.5 pl-8">
            <span className="typing-dot h-1.5 w-1.5 rounded-full bg-[#00EFFF]" />
            <span className="typing-dot h-1.5 w-1.5 rounded-full bg-[#00FFB7]" />
            <span className="typing-dot h-1.5 w-1.5 rounded-full bg-[#A8FF00]" />
          </div>
        </div>

        <div
          data-testid={MARLEA.leadCard}
          className="mt-4 rounded-xl p-3.5 border relative overflow-hidden"
          style={{
            background: "linear-gradient(135deg, rgba(10,10,26,0.7), rgba(22,28,46,0.7))",
            borderColor: "rgba(168,255,0,0.25)",
          }}
        >
          <div
            className="absolute -top-10 -right-10 h-32 w-32 rounded-full blur-3xl opacity-60"
            style={{ background: "radial-gradient(circle, rgba(168,255,0,0.35), transparent 70%)" }}
          />
          <div className="relative">
            <div className="flex items-center justify-between mb-2.5">
              <div className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-[#A8FF00] pulse-dot" />
                <span className="text-[9px] uppercase tracking-[0.18em] font-mono-display text-[#A8FF00]">
                  Nieuwe aanvraag
                </span>
              </div>
              <ArrowUpRight className="h-3.5 w-3.5 text-[#00EFFF]" />
            </div>

            <div className="grid grid-cols-2 gap-2.5">
              <div>
                <div className="text-[9px] uppercase tracking-wider text-[#A7A7A7] mb-0.5">Naam</div>
                <div className="text-white font-medium text-[13px]">Jan Peeters</div>
              </div>
              <div>
                <div className="text-[9px] uppercase tracking-wider text-[#A7A7A7] mb-0.5">Interesse</div>
                <div className="text-white font-medium text-[13px]">Offerte / afspraak</div>
              </div>
              <div className="col-span-2">
                <div className="text-[9px] uppercase tracking-wider text-[#A7A7A7] mb-0.5">Status</div>
                <div className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 border border-[#00FFB7]/30 bg-[#00FFB7]/10 text-[#00FFB7] text-[11px] font-medium">
                  <CheckCircle2 className="h-2.5 w-2.5" /> Klaar voor opvolging
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatbotMockup;
